import { Box, Button, Success } from "@bcc-ui/ui-components";
import * as React from "react";
import { useTranslation } from "react-i18next";

import style from "components/audit-log/audit-log-dialog.scss";
import CopyToClipboard from "components/copy-to-clipboard/CopyToClipboard";
import { Notification } from "domain/notification";
import { parseLicenseEventExportData } from "services/licenses/LicenseEventService";
import { formatTimestamp } from "utils/format";
import { useTheme } from "utils/useTheme";

import testIds from "testIds.json";

interface Props {
    notification: Notification;
}

function LicenseEventExportDownloadDialog(props: Props) {
    const { t } = useTranslation();
    const theme = useTheme();

    const [data] = React.useState(() => parseLicenseEventExportData(props.notification.data));

    if (!data || !data.downloadUrl || data.expirationSeconds === undefined) {
        return <div>{data?.error ?? t("LicenseEvent.export.parseError")}</div>;
    }

    const downloadUrl = data.downloadUrl;
    const expiresAt = new Date(new Date(props.notification.creationDate).getTime() + data.expirationSeconds * 1_000);
    const isLinkValid = expiresAt >= new Date();

    return (
        <Box columnLayout gap="Xs" className={style.centeredBody}>
            <Success size={40} color={theme.successIconColor} detailColor={theme.contentBackgroundColor} />
            <div>{t("LicenseEvent.export.exportSuccessZip")}</div>
            <Box marginTop="Md">
                <Button
                    variant="Primary"
                    onClick={() => {
                        window.location.href = downloadUrl;
                    }}
                    disabled={!isLinkValid}
                    testId={testIds.common.exportFileDialog.downloadButton}
                >
                    {t("LicenseEvent.export.downloadEvents")}
                </Button>
            </Box>
            <div>
                <span>{t("Common.downloadLink")}</span>
                <CopyToClipboard value={downloadUrl} />
            </div>
            <div>
                {isLinkValid
                    ? t("Notification.reportNotifications.linkExpiration", {
                          date: formatTimestamp(expiresAt.toISOString()),
                      })
                    : t("Notification.reportNotifications.linkNotAvailable")}
            </div>
        </Box>
    );
}

export default LicenseEventExportDownloadDialog;
